export const SearchIcon = () => {
  return (
    <svg fill="none" height="19" viewBox="0 0 18 19" width="18" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5920_2661)">
        <path
          clipRule="evenodd"
          d="M2.80312 3.03389C5.30982 0.527195 9.37726 0.527195 11.884 3.03389C14.3907 5.54059 14.3907 9.60804 11.884 12.1147C9.37726 14.6214 5.30982 14.6214 2.80312 12.1147C0.296421 9.60804 0.296421 5.54059 2.80312 3.03389Z"
          fill="black"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M4.46968 4.70039C6.12148 3.0486 8.80173 3.0486 10.4535 4.70039C12.1053 6.35219 12.1053 9.03244 10.4535 10.6842C8.80173 12.336 6.12148 12.336 4.46968 10.6842C2.81789 9.03244 2.81789 6.35219 4.46968 4.70039Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M14.0804 12.9658L17.3862 16.2716C17.8858 16.7712 17.8858 17.589 17.3862 18.0872C16.8865 18.5868 16.0702 18.5868 15.5706 18.0872L12.2648 14.7814L14.0804 12.9658Z"
          fill="black"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M15.752 14.636L13.3994 12.2833C12.8998 11.7837 12.0834 11.7837 11.5838 12.2833C11.0842 12.783 11.0842 13.5993 11.5838 14.0989L13.9365 16.4516L15.752 14.636Z"
          fill="black"
          fillRule="evenodd"
        />
        <path d="M10.9206 10.6541L9.95239 11.6223L11.8634 13.5333L12.8316 12.5651L10.9206 10.6541Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_5920_2661">
          <rect fill="white" height="17.6923" transform="translate(0.0682373 0.769226)" width="17.6923" />
        </clipPath>
      </defs>
    </svg>
  );
};
